export default function () {
  const widgetName = 'activitiesWidget';
  const widgetOpts = activitiesWidgetOpts;

  function setCharLimit(el, limit) {
    const text = el.text();
    return text.length > limit ? `${text.substring(0, limit)}...` : text;
  }

  function formatTitle() {
    const title = $(`#${widgetName}`).find('.card-widget-title');
    title.each(function () {
      if ($(this).text().length >= 24) {
        $(this).attr('title', $(this).text());
        $(this).text(setCharLimit($(this), 24));
      }
    });
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      formatTitle();
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 8,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
